import { reduce } from "et3-type-guards";
import { memoize, orderBy } from "lodash";
import { computed, observable, runInAction } from "mobx";
import { apiCallGetOtherAuditorsPerformance } from "../../../api/supervisor-api/api-call-get-other-auditors-performance";
import i18n from "../../../constants/i18n";
import { getSpecificDateWithDays } from "../../../core/et3-date";
import { isDateRangeValid } from "../../../helpers/et3-date-helper";
import { reducerToZeroIfUndefined } from "../../../helpers/et3-picker-data-helper";
import { TAuditPerformance } from "../../../Types";
import { TEt3PickerSingleValue } from "../../../TypesNEW";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";

class OtherAuditorsPerformanceStore {
  adminInput = observable.box<TEt3PickerSingleValue>({
    value: "",
    label: i18n.get("CHOOSE")
  });
  fromDate = observable.box<Date>(
    getSpecificDateWithDays({
      daysSubtracted: 1,
      daysAdded: 0
    })
  );
  toDate = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 0, daysAdded: 1 })
  );
  auditPerformance = observable.box<TAuditPerformance[]>([]);
  auditorsEfficiency = observable.box([]);

  auditPerformanceOrdered = computed(() => {
    const auditPerformanceOrdered = orderBy(
      this.auditPerformance.get(),
      ["auditName"],
      ["asc"]
    );
    return auditPerformanceOrdered;
  });

  setAdmin = (admin: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.adminInput.set(admin);
    });
  };

  getOtherAuditorsPerformanceData = async () => {
    const definedAdminID = reducerToZeroIfUndefined(
      parseInt(this.adminInput.get().value, 10)
    );

    if (
      !isDateRangeValid({
        fromDate: this.fromDate.get(),
        toDate: this.toDate.get(),
        isLimitedToOneMonth: true
      })
    ) {
      return;
    }

    getCoreUIStore().setIsLoading(
      "SUPERVISOR_OTHER_AUDITORS_PERFORMANCE",
      true
    );
    const { data, status, code } = await apiCallGetOtherAuditorsPerformance({
      adminId: definedAdminID,
      dateMin: this.fromDate.get(),
      dateMax: this.toDate.get()
    });
    if (status === "OK") {
      this.auditPerformance.set(data.auditorsPerformanceData);
      this.auditorsEfficiency.set(data.auditorsEfficiencyData);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
    getCoreUIStore().setIsLoading(
      "SUPERVISOR_OTHER_AUDITORS_PERFORMANCE",
      false
    );
  };

  getOtherAuditorsEfficiencyData = () => {
    const finalizedData = this.auditorsEfficiency.get().map((data) => {
      return {
        event_name: reduce(() => data[0], ""),
        supervised_events: reduce(() => data[1], "0"),
        my_minor_errors: reduce(() => data[2], "0"),
        my_major_errors: reduce(() => data[3], "0"),
        total_errors: reduce(() => data[4], "0")
      };
    });
    return finalizedData;
  };
}

const getOtherAuditorsPerformanceStore = memoize(
  () => new OtherAuditorsPerformanceStore(),
  () => 1
);
export default getOtherAuditorsPerformanceStore;
